/**
 * Dnevna mreža za jedan mesec: ponedeljak je prva kolona (kao u CalendarView / setCalendarData).
 *
 * @param {number} year
 * @param {number} monthIndex0 mesec 0–11
 * @returns {{
 *   calendarDays: Array<{ date: number, isCurrentMonth: boolean, month: number, year: number, index: number }>,
 *   numberOfRows: number
 * }}
 */
export function buildMonthCalendarDays(year, monthIndex0) {
    const firstDayOfMonth = new Date(year, monthIndex0, 1)
    let firstDayWeekday = firstDayOfMonth.getDay()
    firstDayWeekday = firstDayWeekday === 0 ? 6 : firstDayWeekday - 1
    const firstDisplayedDate = new Date(year, monthIndex0, 1)
    firstDisplayedDate.setDate(firstDisplayedDate.getDate() - firstDayWeekday)
    const lastDayOfMonth = new Date(year, monthIndex0 + 1, 0)
    const daysInMonth = lastDayOfMonth.getDate()
    const totalCells = firstDayWeekday + daysInMonth > 35 ? 42 : 35
    const lastDisplayedDate = new Date(firstDisplayedDate)
    lastDisplayedDate.setDate(lastDisplayedDate.getDate() + totalCells - 1)

    const calendarDays = []
    const current = new Date(firstDisplayedDate)
    const last = new Date(lastDisplayedDate)
    while (current <= last) {
        const m = current.getMonth()
        const y = current.getFullYear()
        const d = current.getDate()
        const dayOfWeek = current.getDay()
        const index = dayOfWeek === 0 ? 6 : dayOfWeek - 1
        calendarDays.push({
            date: d,
            isCurrentMonth: m === monthIndex0 && y === year,
            month: m,
            year: y,
            index
        })
        current.setDate(current.getDate() + 1)
    }
    return { calendarDays, numberOfRows: calendarDays.length / 7 }
}

/** @param {{ year: number, month: number, date: number }} day — month 0–11 */
export function isCalendarDayFuture(day) {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const cellDate = new Date(day.year, day.month, day.date)
    return cellDate > today
}

/** @param {number} monthIndex0 mesec 0–11 */
export function isSameCalendarMonthAsToday(year, monthIndex0) {
    const now = new Date()
    return year === now.getFullYear() && monthIndex0 === now.getMonth()
}
